<div class="master-management-container">
  
  <app-master-menu (entitySelected)="onEntitySelected($event)"></app-master-menu>

  <div class="content-container">
    
    <div *ngIf="isGlobalMode" style="background: rgba(255, 189, 46, 0.1); border: 1px dashed #ffbd2e; color: #a0aec0; padding: 12px 20px; border-radius: 4px; font-family: monospace; font-size: 12px; display: flex; align-items: center; gap: 10px; margin-bottom: 20px; flex-shrink: 0;">
      <span style="font-size: 16px;">⚡</span>
      <span style="color: #ffbd2e; font-weight: bold;">MODO GLOBAL:</span>
      <span>Mostrando únicamente maestros de configuración global. Seleccione un entorno activo en el menú superior para visualizar y gestionar los maestros operativos.</span>
    </div>

    <ng-container *ngIf="selectedEntity">
      <app-master-form 
        [selectedEntity]="selectedEntity" 
        [entityData]="selectedEntityData" 
        (entitySaved)="onEntitySaved()"
        (formReset)="onFormReset()">
      </app-master-form>
      
      <app-master-list 
        [selectedEntity]="selectedEntity" 
        (entitySelected)="onRowSelected($event)" 
        [refreshTrigger]="refreshTrigger">
      </app-master-list>
    </ng-container>
    
  </div>

  <div class="right-drawer" 
       *ngIf="selectedEntity?.constructor?.name === 'User'"
       [class.collapsed]="!isRoleDrawerOpen">
    
    <div class="drawer-trigger" (click)="toggleRoleDrawer()">
      <svg viewBox="0 0 24 24" [style.transform]="!isRoleDrawerOpen ? 'rotate(180deg)' : 'rotate(0deg)'">
        <path fill="currentColor" d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"></path>
      </svg>
      <span class="vertical-text" *ngIf="!isRoleDrawerOpen">ROLES Y ACCESOS</span>
    </div>

    <div class="drawer-body" *ngIf="isRoleDrawerOpen">
      <div class="drawer-header" style="margin-bottom: 20px;">
        <span class="cyber-title">>_ GESTIÓN DE ROLES</span>
      </div>

      <ng-container *ngIf="selectedEntityData?.id; else emptyDrawerTpl">
        <app-user-role-manager [userId]="selectedEntityData.id"></app-user-role-manager>
      </ng-container>

      <ng-template #emptyDrawerTpl>
        <div class="empty-state-drawer">
          <p style="color: #a0aec0; font-family: monospace; font-size: 12px; text-align: center; margin-top: 50px;">
            >_ Seleccione un usuario de la lista para gestionar sus credenciales y accesos.
          </p>
        </div>
      </ng-template>
    </div>

  </div>

</div>